import { render, staticRenderFns } from "./loadFiles.vue?vue&type=template&id=74079634&scoped=true"
import script from "./loadFiles.vue?vue&type=script&lang=js"
export * from "./loadFiles.vue?vue&type=script&lang=js"
import style0 from "./loadFiles.vue?vue&type=style&index=0&id=74079634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74079634",
  null
  
)

export default component.exports